import PageMeta from "../../components/common/PageMeta";
import EmployeeManagement from "../../components/hotel/EmployeeManagement";

export default function EmployeeManagementPage() {
  return (
    <>
      <PageMeta
        title="Employee Management - SelfServe"
        description="SelfServe Employee Management Dashboard"
      />
      <div className="col-span-12">
        <EmployeeManagement />
      </div>
    </>
  );
}
